
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lUWKo", function(module, exports) {
/**
 * @generated SignedSource<<785e0bcb5725b89b843abc0d9e39d582>>
 * @relayHash 1ff4ca03c384b08512cbe580492073d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3212d8515f02f63ecb6e64f5cf8c67c56a9b0f6f70d016e539ae93df5099a9af
const $147a02bb825416b1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "PaginatedTemplateCategoryList",
            "kind": "LinkedField",
            "name": "templateCategories",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TemplateCategory",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TemplateListTemplateCategoriesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TemplateListTemplateCategoriesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1ff4ca03c384b08512cbe580492073d6",
            "id": "3212d8515f02f63ecb6e64f5cf8c67c56a9b0f6f70d016e539ae93df5099a9af",
            "metadata": {},
            "name": "TemplateListTemplateCategoriesQuery",
            "operationKind": "query",
            "text": "query TemplateListTemplateCategoriesQuery($spaceKey:String!){templateCategories(spaceKey:$spaceKey){nodes{id,name}}}"
        }
    };
}();
$147a02bb825416b1$var$node.hash = "8274b7258189f7803410cd51d5891f52";
var $147a02bb825416b1$export$2e2bcd8739ae039 = $147a02bb825416b1$var$node;


/**
 * @generated SignedSource<<b0fe3fb49bec7cc32c8e8f30266c7dbd>>
 * @relayHash 05a2ed7d721b148ddc8e144174362983
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 51c1ca272a2d8244b60ffb536d476ff6d2c010a24bf4a1a173cf9df601a5ce72
const $5e52237c9effc3ac$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLicensed"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortingScheme"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "teamType"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "sortingScheme",
                    "variableName": "sortingScheme"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "teamType",
                    "variableName": "teamType"
                }
            ],
            "concreteType": "PaginatedTemplateInfoList",
            "kind": "LinkedField",
            "name": "allTemplates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TemplateInfo",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "templateId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentBlueprintId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blueprintModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "itemModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "templateType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "description"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "iconURL"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "darkModeIconURL"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "styleClass"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasWizard"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isNew"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPromoted"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isFavourite"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasGlobalBlueprintContent"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "categoryIds"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "keywords"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "recommendationRank"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "author"
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "isLicensed",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "UserPreferences",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "favouriteTemplateEntityIds"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateListCurrentSpaceQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateListCurrentSpaceQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "05a2ed7d721b148ddc8e144174362983",
            "id": "51c1ca272a2d8244b60ffb536d476ff6d2c010a24bf4a1a173cf9df601a5ce72",
            "metadata": {},
            "name": "TemplateListCurrentSpaceQuery",
            "operationKind": "query",
            "text": "query TemplateListCurrentSpaceQuery($spaceKey:String!,$sortingScheme:String,$isLicensed:Boolean!,$teamType:String)@allowHigherTimeout{allTemplates(spaceKey:$spaceKey,sortingScheme:$sortingScheme,teamType:$teamType){nodes{templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,templateType,name,description,iconURL,darkModeIconURL,styleClass,hasWizard,isNew,isPromoted,isFavourite,hasGlobalBlueprintContent,categoryIds,keywords,recommendationRank,author},pageInfo{hasNextPage}},userPreferences@include(if:$isLicensed){favouriteTemplateEntityIds}}"
        }
    };
}();
$5e52237c9effc3ac$var$node.hash = "6ad6c9c0ffba14980f625117a309dd12";
var $5e52237c9effc3ac$export$2e2bcd8739ae039 = $5e52237c9effc3ac$var$node;


/**
 * @generated SignedSource<<1bde020df5be332d351924bac69c6ddd>>
 * @relayHash a8db36e1220f22ddd9b1a3ba8b1653a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f74a761acc5e39201edc1b8c63569a3fba0635997e8887060d780c17d76ef914
const $74efebbeda1e0e4f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLicensed"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortingScheme"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "teamType"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "sortingScheme",
                    "variableName": "sortingScheme"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "teamType",
                    "variableName": "teamType"
                }
            ],
            "concreteType": "PaginatedTemplateInfoList",
            "kind": "LinkedField",
            "name": "allTemplates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TemplateInfo",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "templateId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentBlueprintId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blueprintModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "itemModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "templateType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "description"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "iconURL"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "darkModeIconURL"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "styleClass"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasWizard"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isNew"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPromoted"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isFavourite"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasGlobalBlueprintContent"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "categoryIds"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "keywords"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "recommendationRank"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "author"
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "isLicensed",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "concreteType": "UserPreferences",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "favouriteTemplateEntityIds"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateListQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateListQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "a8db36e1220f22ddd9b1a3ba8b1653a5",
            "id": "f74a761acc5e39201edc1b8c63569a3fba0635997e8887060d780c17d76ef914",
            "metadata": {},
            "name": "TemplateListQuery",
            "operationKind": "query",
            "text": "query TemplateListQuery($spaceKey:String!,$sortingScheme:String,$isLicensed:Boolean!,$teamType:String)@allowHigherTimeout{allTemplates(spaceKey:$spaceKey,sortingScheme:$sortingScheme,teamType:$teamType){nodes{templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,templateType,name,description,iconURL,darkModeIconURL,styleClass,hasWizard,isNew,isPromoted,isFavourite,hasGlobalBlueprintContent,categoryIds,keywords,recommendationRank,author},pageInfo{hasNextPage}},userPreferences@include(if:$isLicensed){favouriteTemplateEntityIds}}"
        }
    };
}();
$74efebbeda1e0e4f$var$node.hash = "e7c3b9cd189520f1e98192b780cc4adf";
var $74efebbeda1e0e4f$export$2e2bcd8739ae039 = $74efebbeda1e0e4f$var$node;


/**
 * @generated SignedSource<<523f111c5ae801afffa72ab8314b45fc>>
 * @relayHash 9648d887c0dfab09b49c2a3f48ea903a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d684c2c198ff6bc1b85a33c157bd7d2c7dd8bf2fbd19009d3f874178500e289d
const $594e69782e2306f0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "team"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "TemplateListUserQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "TemplateListUserQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "9648d887c0dfab09b49c2a3f48ea903a",
            "id": "d684c2c198ff6bc1b85a33c157bd7d2c7dd8bf2fbd19009d3f874178500e289d",
            "metadata": {},
            "name": "TemplateListUserQuery",
            "operationKind": "query",
            "text": "query TemplateListUserQuery{user:confluence_atlassianUser{id,team}}"
        }
    };
}();
$594e69782e2306f0$var$node.hash = "1379dbc141731554e24df5addf57d64c";
var $594e69782e2306f0$export$2e2bcd8739ae039 = $594e69782e2306f0$var$node;



var $a4TK8 = parcelRequire("a4TK8");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $1eaCJ = parcelRequire("1eaCJ");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $bQm3c = parcelRequire("bQm3c");


var $dhnmv = parcelRequire("dhnmv");


var $eZElj = parcelRequire("eZElj");

var $h4gaA = parcelRequire("h4gaA");

var $ae5hk = parcelRequire("ae5hk");


var $jX1qB = parcelRequire("jX1qB");


var $2DGtt = parcelRequire("2DGtt");


var $iacta = parcelRequire("iacta");


var $10Oe6 = parcelRequire("10Oe6");


var $2sWSU = parcelRequire("2sWSU");


var $kvJHJ = parcelRequire("kvJHJ");


var $66Dsm = parcelRequire("66Dsm");


var $jMyy4 = parcelRequire("jMyy4");


var $7CLBv = parcelRequire("7CLBv");


var $2XqLN = parcelRequire("2XqLN");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");





const $d1406597d3cf68c5$export$fcf6e84d014033ff = (spaceKey, sortingScheme, isLicensed, teamType)=>(_cache, { data: data })=>{
        if (!data) return;
        const cachedResponse = (0, (/*@__PURE__*/$parcel$interopDefault($7CLBv)))((0, $l1uFv.readQueryInterop)({
            query: (0, $74efebbeda1e0e4f$export$2e2bcd8739ae039),
            variables: {
                spaceKey: spaceKey,
                sortingScheme: sortingScheme,
                isLicensed: isLicensed,
                teamType: teamType
            },
            __callerPackage__: "@confluence/template-list"
        }));
        const templateNodes = cachedResponse?.allTemplates?.nodes || [];
        const updatedFavouriteTemplatesList = data?.updateUserPreferences?.favouriteTemplateEntityIds || [];
        const updatedTemplateNodes = (0, $10Oe6.updateFavouriteTemplates)(templateNodes, updatedFavouriteTemplatesList);
        // @ts-ignore
        cachedResponse.userPreferences = data?.updateUserPreferences;
        // @ts-ignore
        cachedResponse.allTemplates.nodes = updatedTemplateNodes;
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $74efebbeda1e0e4f$export$2e2bcd8739ae039),
            data: cachedResponse,
            variables: {
                spaceKey: spaceKey,
                sortingScheme: sortingScheme,
                isLicensed: isLicensed,
                teamType: teamType
            },
            __callerPackage__: "@confluence/template-list"
        });
    };
// Blog post blueprint helpers
const $d1406597d3cf68c5$var$templateIsBlogPost = (template)=>template.contentBlueprintId === (0, $10Oe6.BLOG_CONTENT_BLUEPRINT_ID);
const $d1406597d3cf68c5$var$removeBlogItem = (0, $2XqLN.default)((templates)=>templates.filter((template)=>!$d1406597d3cf68c5$var$templateIsBlogPost(template)));
const $d1406597d3cf68c5$var$addBlogItem = (0, $2XqLN.default)((templates, blogTemplate, locale)=>{
    // Find index for blogTemplate, or the index of the first template which doesn't have a recommendationRank
    // and is alphabetically after blog item
    const index = templates.findIndex((template)=>!template.recommendationRank && template.name.localeCompare(blogTemplate.name, locale) > 0);
    // Remove blogTemplate's recommendationRank, since it is not recommended in the selected space
    delete blogTemplate.recommendationRank;
    // Insert blog item at index
    return index < 0 ? [
        ...templates,
        blogTemplate
    ] : [
        ...templates.slice(0, index),
        blogTemplate,
        ...templates.slice(index)
    ];
});
const $d1406597d3cf68c5$export$8d56588f812ac17f = (selectedSpaceTemplates, currentSpaceTemplates, locale)=>{
    const currentSpaceBlogItem = currentSpaceTemplates.find($d1406597d3cf68c5$var$templateIsBlogPost);
    const selectedSpaceBlogItem = selectedSpaceTemplates.find($d1406597d3cf68c5$var$templateIsBlogPost);
    let mergedTemplates = selectedSpaceTemplates;
    if (!currentSpaceBlogItem && !!selectedSpaceBlogItem) mergedTemplates = $d1406597d3cf68c5$var$removeBlogItem(selectedSpaceTemplates);
    else if (!!currentSpaceBlogItem && !selectedSpaceBlogItem) mergedTemplates = $d1406597d3cf68c5$var$addBlogItem(selectedSpaceTemplates, currentSpaceBlogItem, locale);
    return mergedTemplates;
};









var $eEA8O = parcelRequire("eEA8O");


var $lJDEI = parcelRequire("lJDEI");

/* EmptyStateWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $abC4X = parcelRequire("abC4X");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $45b8791b964abfd4$var$EmptyStateContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18s81nu5 _1yt41n0e",
            __cmplp.className
        ])
    });
});
const $45b8791b964abfd4$export$1392899bd06f8a9d = (emptyStateProps)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($45b8791b964abfd4$var$EmptyStateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $abC4X.default), emptyStateProps));
};


var $5868e6ff3b6b58d6$exports = {};
$5868e6ff3b6b58d6$exports = new URL("EmptyFeatured.73154d42.svg", import.meta.url).toString();


const $1bc15c5abc946d1b$var$i18n = (0, $aXWIB.defineMessages)({
    errorHeader: {
        id: "template-list.templates.empty.header",
        defaultMessage: "No featured templates"
    },
    errorDescription: {
        id: "template-list.templates.empty.description",
        defaultMessage: "Fast-track team success by promoting templates in space settings or making custom templates for your team\u2019s unique needs."
    },
    callToActionLink: {
        id: "template-list.templates.empty.link",
        defaultMessage: "Set up your templates"
    }
});
const $1bc15c5abc946d1b$export$6c86b8c320c41cdd = ({ spaceKey: spaceKey })=>{
    const intl = (0, $aXWIB.useIntl)();
    const templateListPageRoute = (0, $lJDEI.getTemplateListPage)(spaceKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "empty-featured-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $45b8791b964abfd4$export$1392899bd06f8a9d), {
        header: intl.formatMessage($1bc15c5abc946d1b$var$i18n.errorHeader),
        description: intl.formatMessage($1bc15c5abc946d1b$var$i18n.errorDescription),
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "link",
            href: templateListPageRoute
        }, intl.formatMessage($1bc15c5abc946d1b$var$i18n.callToActionLink)),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($5868e6ff3b6b58d6$exports))),
        imageHeight: 180,
        maxImageWidth: 220
    }));
};











var $1iSzD = parcelRequire("1iSzD");



const $ad94a3ada85b6488$var$i18n = (0, $aXWIB.defineMessages)({
    errorHeaderMyTemplates: {
        id: "template-list.templates.empty.my-templates.header",
        // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "You don't have any custom or saved templates"
    },
    errorHeaderMyTemplatesForEP: {
        id: "template-list.templates.empty.my-templates.header.ep",
        defaultMessage: "Embedded content doesn\u2019t support custom and saved templates yet"
    },
    errorDescriptionMyTemplates: {
        id: "template-list.templates.empty.my-templates.description",
        defaultMessage: "Templates you create or star will show up here."
    },
    errorDescriptionMyTemplatesForEP: {
        id: "template-list.templates.empty.my-templates.description.ep",
        defaultMessage: "Open Confluence in a new browser tab to access your custom templates"
    },
    callToActionLinkMyTemplates: {
        id: "template-list.templates.empty.my-templates.link",
        defaultMessage: "How to create a template"
    }
});
const $ad94a3ada85b6488$export$7bf09e4535d363aa = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "empty-my-templates-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $45b8791b964abfd4$export$1392899bd06f8a9d), {
        header: isEmbeddedConfluence ? intl.formatMessage($ad94a3ada85b6488$var$i18n.errorHeaderMyTemplatesForEP) : intl.formatMessage($ad94a3ada85b6488$var$i18n.errorHeaderMyTemplates),
        description: isEmbeddedConfluence ? intl.formatMessage($ad94a3ada85b6488$var$i18n.errorDescriptionMyTemplatesForEP) : intl.formatMessage($ad94a3ada85b6488$var$i18n.errorDescriptionMyTemplates),
        primaryAction: !isEmbeddedConfluence && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "link",
            href: "https://support.atlassian.com/confluence-cloud/docs/create-a-template/",
            target: "_blank",
            rel: "noreferrer noopener"
        }, intl.formatMessage($ad94a3ada85b6488$var$i18n.callToActionLinkMyTemplates)),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($5868e6ff3b6b58d6$exports))),
        imageHeight: 180,
        maxImageWidth: 220
    }));
};











var $c1d5790fe7e22dd1$exports = {};
$c1d5790fe7e22dd1$exports = new URL("Empty.be4fbe83.svg", import.meta.url).toString();


const $b9ae843a985b39b7$var$i18n = (0, $aXWIB.defineMessages)({
    header: {
        id: "template-list.empty.headline",
        defaultMessage: "We\u2019re fresh out of templates"
    },
    description: {
        id: "template-list.empty.description",
        defaultMessage: "There aren\u2019t any templates in this space, but there are still lots of way to make your pages pop."
    }
});
const $b9ae843a985b39b7$var$HandyTipLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
    appearance: "link",
    href: "https://support.atlassian.com/confluence-cloud/docs/add-formatting-to-your-page/"
}, "Check out these tips");
const $b9ae843a985b39b7$export$53d249c3c46ff473 = (0, $aXWIB.injectIntl)(class EmptyTemplateList extends (0, $42omo.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $45b8791b964abfd4$export$1392899bd06f8a9d), {
            header: this.props.intl.formatMessage($b9ae843a985b39b7$var$i18n.header),
            description: this.props.intl.formatMessage($b9ae843a985b39b7$var$i18n.description),
            primaryAction: $b9ae843a985b39b7$var$HandyTipLink,
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c1d5790fe7e22dd1$exports))),
            imageHeight: 75
        });
    }
});








var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");





var $1kHsc = parcelRequire("1kHsc");


var $d7d88d11593e09c7$exports = {};
$d7d88d11593e09c7$exports = new URL("Error.cd21964e.svg", import.meta.url).toString();


const $b1d6b31654a90829$var$i18n = (0, $aXWIB.defineMessages)({
    header: {
        id: "template-list.error.headline",
        defaultMessage: "We couldn\u2019t load your templates"
    },
    description: {
        id: "template-list.error.description",
        defaultMessage: // eslint-disable-next-line no-restricted-syntax
        "We're having trouble loading templates right now.{lineBreak} Refresh the page to try again."
    },
    spaceErrorHeader: {
        id: "template-list.space-error.header",
        defaultMessage: "Unable to load templates"
    },
    spaceErrorDescription: {
        id: "template-list.space-error.description",
        defaultMessage: "This space may no longer exist, be archived, or you don\u2019t have permissions to see it.{lineBreak} Check archives or reach out to your space admin to restore your access."
    }
});
var $b1d6b31654a90829$var$ErrorType = /*#__PURE__*/ function(ErrorType) {
    ErrorType[ErrorType["DEFAULT"] = 0] = "DEFAULT";
    ErrorType[ErrorType["UNAUTHORIZED"] = 1] = "UNAUTHORIZED";
    ErrorType[ErrorType["TOO_MANY_REQUESTS"] = 2] = "TOO_MANY_REQUESTS";
    ErrorType[ErrorType["INVALID_SPACE"] = 3] = "INVALID_SPACE";
    return ErrorType;
}($b1d6b31654a90829$var$ErrorType || {});
const $b1d6b31654a90829$var$lineBreak = {
    lineBreak: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null)
};
const $b1d6b31654a90829$var$ErrorTemplateListComponent = ({ intl: intl, selectedSpaceError: selectedSpaceError, categoriesError: categoriesError })=>{
    const getErrorType = (error)=>{
        const statusCode = (0, $aMcHK.getStatusCode)(error?.graphQLErrors?.[0]);
        const isSpaceNotFound = error?.graphQLErrors?.[0]?.message.toLowerCase().includes('invalid spacekeys') && statusCode === '404';
        if (isSpaceNotFound) return 3;
        return 0;
    };
    const errorType = getErrorType(selectedSpaceError || categoriesError);
    const getHeaderMessage = ()=>{
        if (errorType === 3) return intl.formatMessage($b1d6b31654a90829$var$i18n.spaceErrorHeader);
        else return intl.formatMessage($b1d6b31654a90829$var$i18n.header);
    };
    const getDescriptionMessage = ()=>{
        if (errorType === 3) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...$b1d6b31654a90829$var$i18n.spaceErrorDescription,
            values: $b1d6b31654a90829$var$lineBreak
        });
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...$b1d6b31654a90829$var$i18n.description,
            values: $b1d6b31654a90829$var$lineBreak
        });
    };
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    if (errorType === 3) {
        (0, $7Sm4c.markErrorAsHandled)(selectedSpaceError);
        (0, $7Sm4c.markErrorAsHandled)(categoriesError);
        experienceTracker.succeed({
            name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_TEMPLATE_LIST_EXPERIENCE)
        });
        experienceTracker.succeed({
            name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE)
        });
    } else {
        experienceTracker.fail({
            name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_TEMPLATE_LIST_EXPERIENCE),
            error: selectedSpaceError
        });
        experienceTracker.fail({
            name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE),
            error: categoriesError || selectedSpaceError
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $45b8791b964abfd4$export$1392899bd06f8a9d), {
        header: getHeaderMessage(),
        description: getDescriptionMessage(),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($d7d88d11593e09c7$exports))),
        imageHeight: 109
    });
};
const $b1d6b31654a90829$export$4dc4093da0962748 = (0, $aXWIB.injectIntl)($b1d6b31654a90829$var$ErrorTemplateListComponent);








var $8a2c91b07b8f6bbc$exports = {};
$8a2c91b07b8f6bbc$exports = new URL("SearchError.b967f6ea.svg", import.meta.url).toString();


const $c98bc25ddebf5263$var$i18n = (0, $aXWIB.defineMessages)({
    header: {
        id: "template-list.empty-search-results.headline",
        defaultMessage: "We couldn\u2019t find any templates"
    },
    description: {
        id: "template-list.empty-search-results.description",
        defaultMessage: "No templates matched your search.{lineBreak} Try again with different keywords."
    }
});
const $c98bc25ddebf5263$var$lineBreak = {
    lineBreak: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null)
};
const $c98bc25ddebf5263$export$75834aadea58796e = (0, $aXWIB.injectIntl)(class NoSearchResultsTemplateList extends (0, $42omo.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $45b8791b964abfd4$export$1392899bd06f8a9d), {
            header: this.props.intl.formatMessage($c98bc25ddebf5263$var$i18n.header),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                ...$c98bc25ddebf5263$var$i18n.description,
                values: $c98bc25ddebf5263$var$lineBreak
            }),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8a2c91b07b8f6bbc$exports))),
            imageHeight: 109
        });
    }
});














var $aJPUt = parcelRequire("aJPUt");

/* TemplateCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $1bHXt = parcelRequire("1bHXt");


var $5nBzc = parcelRequire("5nBzc");


var $8tdj3 = parcelRequire("8tdj3");


var $fVUfS = parcelRequire("fVUfS");


var $5cryL = parcelRequire("5cryL");


var $c2cyb = parcelRequire("c2cyb");

/**
 * @generated SignedSource<<e4d87c0c54269188aea3910045a0a36a>>
 * @relayHash 40bcb595f919202166f0037b79a49e67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a74a8edc9311504064535945cb3b6820e63b7fbfce4b80ddd169c71d22675623
const $01a64869cf1f1cef$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isFavourite"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "templateEntityId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "isFavourite",
                                    "variableName": "isFavourite"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "templateEntityId",
                                    "variableName": "templateEntityId"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "templateEntityFavouriteStatus"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "favouriteTemplateEntityIds"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "StarTemplateFavouriteStatusMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "StarTemplateFavouriteStatusMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "40bcb595f919202166f0037b79a49e67",
            "id": "a74a8edc9311504064535945cb3b6820e63b7fbfce4b80ddd169c71d22675623",
            "metadata": {},
            "name": "StarTemplateFavouriteStatusMutation",
            "operationKind": "mutation",
            "text": "mutation StarTemplateFavouriteStatusMutation($isFavourite:Boolean!,$templateEntityId:String!){updateUserPreferences(userPreferences:{templateEntityFavouriteStatus:{isFavourite:$isFavourite,templateEntityId:$templateEntityId}}){favouriteTemplateEntityIds}}"
        }
    };
}();
$01a64869cf1f1cef$var$node.hash = "93b3caaa701852fd7c778b8b1736cc7e";
var $01a64869cf1f1cef$export$2e2bcd8739ae039 = $01a64869cf1f1cef$var$node;












var $kfYj7 = parcelRequire("kfYj7");


var $3gadb = parcelRequire("3gadb");











var $bvJMy = parcelRequire("bvJMy");


var $308Wd = parcelRequire("308Wd");

/* TemplateCardStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $121ba942e514b32a$export$f99233281efd08a0 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _11c81qyo _1tke8jkm _c71l10mc _1e0ccj1k _1yyjcs5v _sudp1e54 _1bto1l2s _syazi7uo",
            __cmplp.className
        ])
    });
});
const $121ba942e514b32a$export$393edc798c47379d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _11c8wadc _19pk1b66 _1tke7vkz _c71lvbgk _1e0ccj1k _1yyjegat _sudp1e54 _1bto1l2s _syaz1rpy _k48pi7a9",
            __cmplp.className
        ])
    });
});
const $121ba942e514b32a$var$itemContainerSelector = 'template-card.ItemContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $121ba942e514b32a$export$ed8671f612970784 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswstnw _1xi2v77o _154iv77o _1aaxusic",
            __cmplp.className
        ])
    });
});
$121ba942e514b32a$export$ed8671f612970784.defaultProps = {
    'data-styled-selector': $121ba942e514b32a$var$itemContainerSelector
};
const $121ba942e514b32a$var$starContainerSelector = 'template-card.StarContainer';
const $121ba942e514b32a$export$c70bb259c5e87f96 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19it8cnq _bfhk1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _1aaxusic _11vn1rr0 _1uvf1e03 _j5dh1kw7 _1h7hkb7n",
            __cmplp.isVisible ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
$121ba942e514b32a$export$c70bb259c5e87f96.defaultProps = {
    'data-styled-selector': $121ba942e514b32a$var$starContainerSelector
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $121ba942e514b32a$export$31dea26885d599bc = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _1ipk1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $121ba942e514b32a$export$35e09ba17cc51c69 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulp12x7 _1e0c1txw _4cvr1h6o _19pkr5cr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $121ba942e514b32a$export$6027454d331df3c4 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _otyrpxbi _16oskb7n",
            __cmplp.className
        ])
    });
});


const $b09c3e93bc8ced07$var$i18n = (0, $aXWIB.defineMessages)({
    star: {
        id: "template-card.star.label",
        defaultMessage: "Star {templateName}"
    },
    starTooltip: {
        id: "template-card.star.tooltip",
        defaultMessage: "Star this template"
    },
    filledStar: {
        id: "template-card.filled-star.label",
        defaultMessage: "Unstar {templateName}"
    },
    filledStarTooltip: {
        id: "template-card.filled-star.tooltip",
        defaultMessage: "Unstar this template"
    }
});
const $b09c3e93bc8ced07$var$StarComponent = (0, $aXWIB.injectIntl)(({ isDisabled: isDisabled, template: template, onStarClick: onStarClick, intl: intl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const templateId = (0, $10Oe6.getTemplateId)(template);
    const isFavourite = template.isFavourite;
    const [updateUserPreferences, { loading: isUserPreferencesLoading, error: error }] = (0, $308Wd.useMutationInterop)((0, $01a64869cf1f1cef$export$2e2bcd8739ae039), {
        __callerPackage__: "@confluence/template-card"
    });
    (0, $42omo.useEffect)(()=>{
        if (error) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'templateDrawer',
                action: 'error',
                actionSubject: 'button',
                actionSubjectId: 'templateStarClickedError',
                attributes: {
                    isFavourite: isFavourite,
                    templateId: templateId,
                    errorMessage: error.message,
                    starAction: isFavourite ? 'unstarring' : 'starring'
                }
            }
        }).fire();
    }, [
        error,
        createAnalyticsEvent,
        templateId,
        isFavourite
    ]);
    const star = (0, $42omo.useCallback)(async (e)=>{
        e.persist();
        e.stopPropagation();
        if (isUserPreferencesLoading || !onStarClick) return;
        try {
            await updateUserPreferences({
                variables: {
                    isFavourite: true,
                    templateEntityId: templateId
                },
                update: onStarClick
            });
        } catch  {
        // error handled by useMutation result
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        updateUserPreferences,
        isUserPreferencesLoading,
        templateId,
        onStarClick,
        updateUserPreferences
    ]);
    const unstar = (0, $42omo.useCallback)(async (e)=>{
        e.persist();
        e.stopPropagation();
        if (isUserPreferencesLoading || !onStarClick) return;
        try {
            await updateUserPreferences({
                variables: {
                    isFavourite: false,
                    templateEntityId: templateId
                },
                update: onStarClick
            });
        } catch  {
        // error handled by useMutation result
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        updateUserPreferences,
        isUserPreferencesLoading,
        templateId,
        onStarClick,
        updateUserPreferences
    ]);
    if (isFavourite) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        key: 0,
        content: isDisabled ? null : intl.formatMessage($b09c3e93bc8ced07$var$i18n.filledStarTooltip),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $121ba942e514b32a$export$c70bb259c5e87f96), {
        isVisible: true,
        onClick: unstar,
        disabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bvJMy.StarSelectedIcon), {
        label: intl.formatMessage($b09c3e93bc8ced07$var$i18n.filledStar, {
            templateName: template.name
        }),
        testId: "template-card-filled-star"
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        key: 1,
        content: isDisabled ? null : intl.formatMessage($b09c3e93bc8ced07$var$i18n.starTooltip),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $121ba942e514b32a$export$c70bb259c5e87f96), {
        onClick: star,
        disabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kfYj7))), {
        spacing: "spacious",
        label: intl.formatMessage($b09c3e93bc8ced07$var$i18n.star, {
            templateName: template.name
        }),
        testId: "template-card-star",
        color: "var(--ds-icon, #292A2E)"
    }))));
});
const $b09c3e93bc8ced07$export$1644ba17714857f1 = (props)=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    return isLicensed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b09c3e93bc8ced07$var$StarComponent, props) : null;
};



// React.memo loses generic typings: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/37087#issuecomment-542793243
const $44125e5309502726$var$typedMemo = (0, $42omo.memo);
const $44125e5309502726$var$i18n = (0, $aXWIB.defineMessages)({
    tutorial: {
        id: "template-card.onboarding.tutorial",
        defaultMessage: "Tutorial"
    }
});
const $44125e5309502726$var$styles = {
    avatarItem: "_2rko12b0 _1yt4u2gc _1dqonqa1 _189e1dm9 _1h6d1j28 _1e0c1txw _4cvr1h6o _bfhk1j28 _1bsb1osq _y3gn1e5h _gw8ckb7n _irr31dpa",
    avatarItemBleed: "_2rkoidpf _18zr1ejb _195gmgjw _1bsb1gud",
    avtarItemActive: "_bfhk15s3",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _p12f1osq _bozgu2gc",
    avatarItemPrimaryText: "_syazi7uo",
    avatarItemSecondaryText: "_11c8fhey _syaz1rpy"
};
const $44125e5309502726$export$ba340e850b866867 = $44125e5309502726$var$typedMemo(({ template: template, onItemClick: onItemClick, onStarClick: onStarClick, isDisabled: isDisabled, isActive: isActive, hasHighlightBleed: hasHighlightBleed })=>{
    const title = template.name || '';
    const description = template.description || '';
    const recommendationRank = template.recommendationRank || null;
    const moduleKey = template.blueprintModuleCompleteKey || '';
    let titleComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $121ba942e514b32a$export$35e09ba17cc51c69), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $121ba942e514b32a$export$f99233281efd08a0), null, title));
    let descriptionComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $121ba942e514b32a$export$393edc798c47379d), null, description);
    const isOnboardingTemplate = moduleKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY) || moduleKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED);
    if (isOnboardingTemplate) {
        titleComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $121ba942e514b32a$export$35e09ba17cc51c69), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $121ba942e514b32a$export$f99233281efd08a0), null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            testId: "tutorial-lozenge",
            appearance: "new"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $44125e5309502726$var$i18n.tutorial)));
        descriptionComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $121ba942e514b32a$export$31dea26885d599bc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $121ba942e514b32a$export$393edc798c47379d), null, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
            label: "",
            testId: "template-card-shortcut-icon"
        }));
    }
    const onClick = (0, $42omo.useCallback)(()=>{
        onItemClick && onItemClick(template, {
            recommendationRank: recommendationRank
        });
    }, [
        onItemClick,
        template,
        recommendationRank
    ]); // @todo CTE-337 remove isDisabled check for active highlight
    // when callback for close and create for dialog and drawer are in place
    const active = isActive && isDisabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $121ba942e514b32a$export$6027454d331df3c4), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default // @ts-expect-error -- StrictXCSSProp rejects `width: calc(...)` on
    ), {
        // `avatarItemBleed`; the bleed variant must extend the pressable 16px past its
        // parent on each inline edge to align with the ListWrapper highlight bleed.
        xcss: (0, $1bHXt.cx)($44125e5309502726$var$styles.avatarItem, hasHighlightBleed && $44125e5309502726$var$styles.avatarItemBleed, active && $44125e5309502726$var$styles.avtarItemActive),
        onClick: onClick,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c2cyb.TemplateIcon), {
        isDisabled: isDisabled,
        template: template
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $44125e5309502726$var$styles.avatarItemTextWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $44125e5309502726$var$styles.avatarItemPrimaryText
        ])
    }, titleComponent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $44125e5309502726$var$styles.avatarItemSecondaryText
        ])
    }, descriptionComponent))), isOnboardingTemplate ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $121ba942e514b32a$export$ed8671f612970784), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b09c3e93bc8ced07$export$1644ba17714857f1), {
        isDisabled: isDisabled,
        template: template,
        onStarClick: onStarClick
    })));
}, (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8))));






var $4B2M3 = parcelRequire("4B2M3");


var $dMoBp = parcelRequire("dMoBp");

const $b6c79cd861291de5$export$22524a607d8ba3dd = /*#__PURE__*/ (0, $42omo.memo)(({ onTemplateSelect: onTemplateSelect, templates: templates, isDisabled: isDisabled, onStarClick: onStarClick = ()=>{}, onTemplateMouseEnter: onTemplateMouseEnter = ()=>{}, onTemplateListMouseLeave: onTemplateListMouseLeave = ()=>{}, selectedTemplateKey: selectedTemplateKey, templatesPageSize: templatesPageSize, hasHighlightBleed: hasHighlightBleed })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [paginationSlice, setPaginationSlice] = (0, $42omo.useState)(1);
    const renderItemComponent = (template, index)=>{
        const key = (0, $10Oe6.getTemplateKey)(template);
        const isActive = selectedTemplateKey === key;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": key,
            onMouseEnter: getTemplateEventHandler(template, index),
            onFocus: getTemplateEventHandler(template, index),
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $44125e5309502726$export$ba340e850b866867), {
            template: template,
            onItemClick: handleTemplateClick({
                position: index + 1
            }),
            isActive: isActive,
            isDisabled: isDisabled,
            onStarClick: onStarClick,
            hasHighlightBleed: hasHighlightBleed
        }));
    };
    const getTemplateEventHandler = (template, index)=>{
        return (e)=>{
            handleTemplateMouseOverAndFocus(template, e.currentTarget.getBoundingClientRect(), index);
        };
    };
    const handleTemplateMouseOverAndFocus = (template, element, index)=>{
        if (isDisabled) return;
        experienceTracker.start({
            name: (0, $irVI7.TEMPLATE_PREVIEW_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).TEMPLATE_PREVIEW,
            attributes: {
                source: 'templateDrawer',
                ...(0, $10Oe6.getTemplateIdAttributesForAnalytics)(template)
            }
        });
        onTemplateMouseEnter(template, element, index);
    };
    const handleTemplateClick = (templateListComponentAdditionalStatAttributes)=>(template, additionalStatAttributes)=>{
            onTemplateListMouseLeave();
            onTemplateSelect(template, {
                ...templateListComponentAdditionalStatAttributes,
                ...additionalStatAttributes
            });
        };
    const handleNextPage = ()=>{
        setPaginationSlice(paginationSlice + 1);
    };
    const numRenderedTemplates = templatesPageSize * paginationSlice;
    const hasNextTemplatesPage = numRenderedTemplates < templates.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onMouseLeave: onTemplateListMouseLeave,
        onBlur: onTemplateListMouseLeave,
        "data-testid": "template-list-wrapper"
    }, templates.slice(0, numRenderedTemplates).map(renderItemComponent), hasNextTemplatesPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMoBp.InfiniteScrollWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4B2M3.ObservableSpinner), {
        cursor: String(paginationSlice),
        onScrollTo: handleNextPage,
        testId: "template-list-observable-spinner",
        observerOptions: {
            root: null,
            rootMargin: '0px',
            threshold: 0.05
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_TEMPLATE_LIST_EXPERIENCE)
    }));
});



var $6f6I4 = parcelRequire("6f6I4");




const $ebc6a298c3f20244$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    allCategoryName: {
        id: "template-list.categories.all.category.name",
        defaultMessage: "All"
    },
    featuredCategoryName: {
        id: "template-list.categories.featured.category.name",
        defaultMessage: "Featured"
    },
    myTemplatesCategoryName: {
        id: "template-list.categories.my-templates.category.name",
        defaultMessage: "My Templates"
    },
    allTemplatesCountDisplay: {
        id: "template-list.template.count.all",
        defaultMessage: "{totalTemplatesCount, plural, one {Displaying the only template available.} other {Displaying all {totalTemplatesCount} templates.}}"
    },
    filteredTemplatesCountDisplay: {
        id: "template-list.template.count.filtered",
        defaultMessage: "{totalTemplatesCount, plural, one {Displaying {filteredTemplatesCount} of {totalTemplatesCount} template.} other {Displaying {filteredTemplatesCount} of {totalTemplatesCount} templates.}}"
    }
});
const $ebc6a298c3f20244$var$DEFAULT_TEMPLATES_PAGE_SIZE = 25;
const $ebc6a298c3f20244$var$TemplateListBase = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_MODES
})(({ intl: intl, onTemplateSelect: onTemplateSelect, spaceKey: selectedSpaceKey, currentSpaceKey: currentSpaceKey, searchQuery: searchQuery, selectedTemplateKey: selectedTemplateKey = '', isDisabled: isDisabled = false, templatesPageSize: templatesPageSize = $ebc6a298c3f20244$var$DEFAULT_TEMPLATES_PAGE_SIZE, templateBlueprintAllowList: templateBlueprintAllowList = [], hasHighlightBleed: hasHighlightBleed })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isLicensed: isLicensed, userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const useTemplateInCurrentSpace = !!currentSpaceKey;
    const trimmedSearchQuery = searchQuery ? searchQuery.trim() : undefined;
    const prevSearchQuery = (0, $42omo.useRef)(trimmedSearchQuery);
    const prevSpaceKey = (0, $42omo.useRef)(selectedSpaceKey);
    const prevCategoryIds = (0, $42omo.useRef)([]);
    const lastSelectedCategoryIds = (0, $42omo.useRef)([]);
    const listWrapperRef = (0, $42omo.useRef)();
    const [selectedCategoryIds, setSelectedCategoryIds] = (0, $42omo.useState)([]);
    const [selectedSortOrder, setSelectedSortOrder] = (0, $42omo.useState)((0, $ae5hk.SortOrders).RELEVANCY_SORT);
    const { shouldIncludeEditorTutorialTemplate: shouldIncludeEditorTutorialTemplate, userContentError: userContentError, editorOnboardingError: editorOnboardingError, privilegeError: privilegeError, isProductOrSiteAdmin: isProductOrSiteAdmin } = (0, $66Dsm.useIncludeEditorTutorialTemplate)();
    const { data: userData, error: userDataError } = (0, $jMyy4.useQueryInterop)((0, $594e69782e2306f0$export$2e2bcd8739ae039), {
        skip: !isProductOrSiteAdmin,
        __callerPackage__: "@confluence/template-list"
    });
    const teamType = userData?.user?.team;
    const { data: selectedSpaceData, loading: selectedSpaceLoading, error: selectedSpaceError } = (0, $jMyy4.useQueryInterop)((0, $74efebbeda1e0e4f$export$2e2bcd8739ae039), {
        errorPolicy: 'all',
        variables: {
            spaceKey: selectedSpaceKey,
            sortingScheme: selectedSortOrder,
            isLicensed: isLicensed,
            teamType: teamType
        },
        __callerPackage__: "@confluence/template-list"
    });
    const { data: currentSpaceData, loading: currentSpaceLoading, error: currentSpaceError } = (0, $jMyy4.useQueryInterop)((0, $5e52237c9effc3ac$export$2e2bcd8739ae039), {
        errorPolicy: 'all',
        variables: {
            spaceKey: currentSpaceKey,
            sortingScheme: selectedSortOrder,
            isLicensed: isLicensed,
            teamType: teamType
        },
        skip: !useTemplateInCurrentSpace,
        __callerPackage__: "@confluence/template-list"
    });
    const { data: categoriesData, loading: categoriesLoading, error: categoriesError } = (0, $jMyy4.useQueryInterop)((0, $147a02bb825416b1$export$2e2bcd8739ae039), {
        errorPolicy: 'all',
        variables: {
            spaceKey: selectedSpaceKey
        },
        __callerPackage__: "@confluence/template-list"
    });
    const hasTemplatesData = !!selectedSpaceData && (!useTemplateInCurrentSpace || !!currentSpaceData);
    const hasTemplatesLoading = selectedSpaceLoading || currentSpaceLoading;
    const hasTemplatesError = !!selectedSpaceError || !!currentSpaceError;
    const categories = categoriesData?.templateCategories?.nodes || [];
    let templates = selectedSpaceData?.allTemplates?.nodes || [];
    const hasNextPage = selectedSpaceData?.allTemplates?.pageInfo?.hasNextPage || false;
    const initialFavouritedTemplatesList = selectedSpaceData?.userPreferences?.favouriteTemplateEntityIds || [];
    if (useTemplateInCurrentSpace && !hasTemplatesLoading && !(selectedSpaceError && templates.length === 0) && !currentSpaceError && selectedSpaceKey !== currentSpaceKey) {
        const currentTemplates = currentSpaceData?.allTemplates?.nodes || [];
        templates = (0, $d1406597d3cf68c5$export$8d56588f812ac17f)(templates, currentTemplates, intl.locale);
    }
    let templatesForSearchQuery = (0, $10Oe6.filterEditorTutorialTemplate)(templates, shouldIncludeEditorTutorialTemplate, selectedSortOrder);
    templatesForSearchQuery = (0, $10Oe6.filterTemplatesByAllowList)(templatesForSearchQuery, templateBlueprintAllowList);
    // If the user is a new user in the onboarding state/has published <2 pages/the onboarding state is
    // not loading, then they will see the editor tutorial template. Otherwise it will be filtered out, so
    // we need to show the correct total template count.
    const totalSpaceTemplatesCount = shouldIncludeEditorTutorialTemplate && templateBlueprintAllowList.length === 0 ? templates.length : templatesForSearchQuery.length;
    templatesForSearchQuery = (0, $10Oe6.filterTemplatesBySearchQuery)(templatesForSearchQuery, intl, currentUserId, trimmedSearchQuery);
    const renderedCategoryIds = selectedCategoryIds;
    // has to go after the filter so that it knows which templates to count
    // it doesn't apply to rendered templates for some reason if moved before the search query filter
    if (!hasTemplatesLoading) // Update the templatelist using userpref as source of truth
    // The fields related to starring may be stale for global templates and blueprints
    // as cache is space level and not global for templates and blueprints
    templatesForSearchQuery = (0, $10Oe6.updateFavouriteTemplates)(templatesForSearchQuery, initialFavouritedTemplatesList);
    // filtering by category is done right here and not in
    // useEffect(...) and with setSelectedCategory(...) in order
    // to achieve simultaneous update when both query and category
    // filters applied. In contrast, using setSelectedCategory(...)
    // in useEffect(..., [searchQuery]) will lead to subsequent rerender.
    const renderedCategories = (0, $iacta.getCountedCategories)(templatesForSearchQuery, categories);
    const isCategoryPresent = (categoryId)=>{
        return renderedCategories.find((category)=>category.id == categoryId);
    };
    if (templatesForSearchQuery.length) {
        const featuredCategoryCount = (0, $10Oe6.getFeaturedCategoryCount)(templatesForSearchQuery);
        // We either show featured pill if there are any, or we show empty state to admins
        if ((featuredCategoryCount || isProductOrSiteAdmin) && !isCategoryPresent((0, $iacta.FEATURED_CATEGORY_ID))) renderedCategories.unshift({
            id: (0, $iacta.FEATURED_CATEGORY_ID),
            name: intl.formatMessage($ebc6a298c3f20244$export$a7357cdd1f0b0168.featuredCategoryName),
            count: featuredCategoryCount
        });
        if (!isCategoryPresent((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) renderedCategories.unshift({
            id: (0, $iacta.MY_TEMPLATES_CATEGORY_ID),
            name: intl.formatMessage($ebc6a298c3f20244$export$a7357cdd1f0b0168.myTemplatesCategoryName),
            count: (0, $10Oe6.getMyTemplatesCategoryCount)(templatesForSearchQuery, currentUserId || '0')
        });
    }
    const renderedTemplates = (0, $10Oe6.filterTemplatesByCategoryIds)(templatesForSearchQuery, renderedCategoryIds, selectedSortOrder, currentUserId || '0');
    (0, $42omo.useEffect)(()=>{
        (0, $2DGtt.requireStyleClassResourcesForTemplates)();
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (!prevSearchQuery.current && trimmedSearchQuery) {
            lastSelectedCategoryIds.current = selectedCategoryIds;
            if (selectedCategoryIds.length) setSelectedCategoryIds([]);
        }
        if (!trimmedSearchQuery && prevSearchQuery.current) setSelectedCategoryIds(lastSelectedCategoryIds.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        trimmedSearchQuery
    ]);
    (0, $42omo.useEffect)(()=>{
        if (hasTemplatesLoading || hasTemplatesError) return;
        // Maps out a new array of categoryIds so that when the space is changed and a previously selected
        // category no longer exists in the new space, the template list can rerender and show templates that belong to
        // selected categories that exist in the new space.
        const existingCategoryIds = (0, $10Oe6.getExistingCategoryIds)(renderedCategories, renderedCategoryIds);
        const hasQueryChanged = prevSearchQuery.current !== trimmedSearchQuery;
        const hasSpaceChanged = prevSpaceKey.current !== selectedSpaceKey;
        const haveCategoriesChanged = !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(prevCategoryIds.current, renderedCategoryIds) || !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(prevCategoryIds.current, existingCategoryIds);
        if (hasSpaceChanged) setSelectedCategoryIds(existingCategoryIds);
        if (hasQueryChanged || hasSpaceChanged || haveCategoriesChanged) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'templateDrawer',
                action: 'updated',
                actionSubject: 'templateDrawer',
                actionSubjectId: 'searchResultUpdated',
                attributes: {
                    hasQueryChanged: hasQueryChanged,
                    hasSpaceChanged: hasSpaceChanged,
                    haveCategoriesChanged: haveCategoriesChanged
                }
            }
        }).fire();
        prevSearchQuery.current = trimmedSearchQuery;
        prevSpaceKey.current = selectedSpaceKey;
        prevCategoryIds.current = renderedCategoryIds;
    }, [
        hasTemplatesLoading,
        hasTemplatesError,
        trimmedSearchQuery,
        selectedSpaceKey,
        setSelectedCategoryIds,
        createAnalyticsEvent,
        renderedTemplates,
        renderedCategories,
        renderedCategoryIds
    ]);
    const handleCategorySelected = (0, $42omo.useCallback)((category)=>{
        let selectedCategoryIds = prevCategoryIds.current;
        setSelectedCategoryIds((previousCategories)=>{
            // Filter previousCategories to exclude the current category's id
            const updatedCategories = previousCategories.filter((id)=>id !== category.id);
            // If the current category's id is in previousCategories, return the filtered categories.
            // Otherwise, add the current category's id to the start of the filtered categories and return that.
            selectedCategoryIds = previousCategories.includes(category.id) ? updatedCategories : [
                category.id,
                ...updatedCategories
            ];
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: 'templateDrawer',
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'templateCategory',
                    attributes: {
                        selectedCategoryIds: selectedCategoryIds
                    }
                }
            }).fire();
            return selectedCategoryIds;
        });
        if (listWrapperRef.current) listWrapperRef.current.scrollTop = 0;
    }, [
        createAnalyticsEvent
    ]);
    const templateListOnTemplateSelect = (0, $42omo.useCallback)((template, additionalStatAttributes)=>{
        onTemplateSelect(template, {
            ...additionalStatAttributes,
            selectedCategoryIds: selectedCategoryIds,
            sortingScheme: selectedSortOrder
        });
    }, [
        onTemplateSelect,
        selectedSortOrder,
        selectedCategoryIds
    ]);
    const onStarClick = (0, $42omo.useMemo)(()=>{
        return (0, $d1406597d3cf68c5$export$fcf6e84d014033ff)(selectedSpaceKey, selectedSortOrder, isLicensed, teamType);
    }, [
        selectedSpaceKey,
        isLicensed,
        selectedSortOrder,
        teamType
    ]);
    if (hasTemplatesLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMoBp.TemplateListContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMoBp.CategoriesWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2sWSU.CategorySelector), {
        categories: renderedCategories,
        selectedCategoryIds: renderedCategoryIds,
        isDisabled: isDisabled,
        onCategorySelected: handleCategorySelected,
        isLoading: categoriesLoading
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMoBp.SortByWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eZElj.LoadingSortByDropdown), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f6I4.LoadingTemplateListCards), null));
    if (selectedSpaceError && templates.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: selectedSpaceError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b1d6b31654a90829$export$4dc4093da0962748), {
        selectedSpaceError: selectedSpaceError,
        categoriesError: categoriesError
    })), categoriesError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: categoriesError
    }), currentSpaceError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: currentSpaceError
    }), userContentError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: userContentError
    }), userDataError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: userDataError
    }), privilegeError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: privilegeError
    }), editorOnboardingError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: editorOnboardingError
    }));
    if (templates.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b9ae843a985b39b7$export$53d249c3c46ff473), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_TEMPLATE_LIST_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE)
    }));
    if (templatesForSearchQuery.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c98bc25ddebf5263$export$75834aadea58796e), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_TEMPLATE_LIST_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE)
    }));
    const handleEmptyStates = ()=>{
        const hasNoFeaturedTemplates = selectedCategoryIds.includes((0, $iacta.FEATURED_CATEGORY_ID)) && !renderedTemplates.length;
        const hasNoMyTemplates = selectedCategoryIds.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID)) && !renderedTemplates.length;
        if (hasNoMyTemplates) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ad94a3ada85b6488$export$7bf09e4535d363aa), null);
        if (hasNoFeaturedTemplates) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1bc15c5abc946d1b$export$6c86b8c320c41cdd), {
            spaceKey: selectedSpaceKey
        });
        return null;
    };
    const shouldUpdateTemplateCount = selectedCategoryIds.length > 0 || searchQuery;
    const templateCountDisplay = ()=>{
        // allTemplates sends up to 500 templates at a time from the BE. After 500 templates, it only sends
        // more templates as the user scrolls (paginated) so if there are more than 500 templates, we want to show
        // 500+ templates to the user.
        const isOver500TotalTemplates = templates.length > 500 && hasNextPage;
        const totalTemplatesCount = isOver500TotalTemplates ? '500+' : totalSpaceTemplatesCount;
        const filteredTemplatesCount = renderedTemplates.length;
        const totalTemplatesCountMessage = intl.formatMessage($ebc6a298c3f20244$export$a7357cdd1f0b0168.allTemplatesCountDisplay, {
            totalTemplatesCount: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, totalTemplatesCount)
        });
        const filteredTemplatesCountMessage = intl.formatMessage($ebc6a298c3f20244$export$a7357cdd1f0b0168.filteredTemplatesCountDisplay, {
            filteredTemplatesCount: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("b", null, filteredTemplatesCount),
            totalTemplatesCount: totalTemplatesCount
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMoBp.CountDisplayWrapper), {
            "data-testid": "count-display"
        }, shouldUpdateTemplateCount ? filteredTemplatesCountMessage : totalTemplatesCountMessage);
    };
    const isNotLoadingAnything = !currentSpaceLoading && !selectedSpaceLoading && !categoriesLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMoBp.TemplateListContainer), null, selectedSpaceError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: selectedSpaceError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_TEMPLATE_LIST_EXPERIENCE),
        error: selectedSpaceError
    })), categoriesError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: categoriesError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE),
        error: categoriesError
    })), currentSpaceError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: currentSpaceError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.IN_EDITOR_TEMPLATES_LOAD_PANEL_TEMPLATE_LIST_EXPERIENCE),
        error: currentSpaceError
    })), userContentError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: userContentError
    }), userDataError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: userDataError
    }), privilegeError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: privilegeError
    }), editorOnboardingError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: editorOnboardingError
    }), hasTemplatesData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metricKey: (0, $jX1qB.IN_EDITOR_TEMPLATES_SEGMENT_KEY)
    }), !!renderedCategories.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMoBp.CategoriesWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2sWSU.CategorySelector), {
        categories: renderedCategories,
        selectedCategoryIds: renderedCategoryIds,
        isDisabled: isDisabled,
        isLoading: categoriesLoading,
        onCategorySelected: handleCategorySelected
    })), handleEmptyStates() || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMoBp.SortByWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h4gaA.SortByDropdown), {
        onChange: setSelectedSortOrder,
        value: selectedSortOrder,
        isDisabled: isDisabled,
        analyticsSource: "templateDrawer"
    })), isNotLoadingAnything && templateCountDisplay(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dMoBp.ListWrapper), {
        ref: listWrapperRef,
        hasBleed: hasHighlightBleed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dhnmv.PopupPreview), {
        spaceKey: selectedSpaceKey,
        templates: renderedTemplates,
        searchQuery: trimmedSearchQuery,
        hoverSource: "templateDrawer",
        renderedCategoryIds: renderedCategoryIds
    }, ({ showPreview: showPreview, hidePreview: hidePreview })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b6c79cd861291de5$export$22524a607d8ba3dd), {
            onTemplateSelect: templateListOnTemplateSelect,
            templates: renderedTemplates,
            selectedTemplateKey: selectedTemplateKey,
            isDisabled: isDisabled,
            onStarClick: onStarClick,
            onTemplateMouseEnter: showPreview,
            onTemplateListMouseLeave: hidePreview,
            templatesPageSize: templatesPageSize,
            hasHighlightBleed: hasHighlightBleed
        })))));
});
const $ebc6a298c3f20244$export$c5a06aa0f041765d = (0, $aXWIB.injectIntl)($ebc6a298c3f20244$var$TemplateListBase);
module.exports["i18n"] = $ebc6a298c3f20244$export$a7357cdd1f0b0168;
module.exports["TemplateList"] = $ebc6a298c3f20244$export$c5a06aa0f041765d;

});

parcelRegister("h4gaA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ghftu = parcelRequire("ghftu");


var $52EPl = parcelRequire("52EPl");


var $ahaN7 = parcelRequire("ahaN7");


var $inPa6 = parcelRequire("inPa6");


var $3gadb = parcelRequire("3gadb");


var $eEA8O = parcelRequire("eEA8O");


var $ae5hk = parcelRequire("ae5hk");


var $eZElj = parcelRequire("eZElj");


var $dHU8P = parcelRequire("dHU8P");


var $9cCqQ = parcelRequire("9cCqQ");

const $2de8447cc174b523$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    sortByLabel: {
        id: "template-utils.sort-by-dropdown.sortBy.label",
        defaultMessage: "Sort by"
    },
    recommendedLabel: {
        id: "template-utils.sort-by-dropdown.sortBy.option.recommended.label",
        defaultMessage: "Recommended"
    },
    alphabeticalLabel: {
        id: "template-utils.sort-by-dropdown.sortBy.option.alphabetical.label",
        defaultMessage: "Alphabetical"
    },
    sortByRecommendedTooltip: {
        id: "template-utils.sort-by-dropdown.sortBy.recommended.tooltip.content",
        defaultMessage: "Recommended templates are sorted by frequency of use"
    }
});
const $2de8447cc174b523$export$90a65afdbb90e76e = ({ onChange: onChange, value: value, isDisabled: isDisabled = false, showLabel: showLabel = true, analyticsSource: analyticsSource })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const options = {
        [(0, $ae5hk.SortOrders).RELEVANCY_SORT]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...$2de8447cc174b523$export$a7357cdd1f0b0168.recommendedLabel,
            key: $2de8447cc174b523$export$a7357cdd1f0b0168.recommendedLabel.id
        }),
        [(0, $ae5hk.SortOrders).ALPHABETICAL_SORT]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            ...$2de8447cc174b523$export$a7357cdd1f0b0168.alphabeticalLabel,
            key: $2de8447cc174b523$export$a7357cdd1f0b0168.alphabeticalLabel.id
        })
    };
    const handleOpenChange = (0, $42omo.useCallback)(({ isOpen: isOpen })=>{
        setIsMenuOpen(isOpen);
        if (isOpen) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsSource,
                action: 'clicked',
                actionSubject: 'dropdown',
                actionSubjectId: 'sortingOrderDropdown'
            }
        }).fire();
    }, [
        setIsMenuOpen,
        analyticsSource,
        createAnalyticsEvent
    ]);
    const handleSortOrderChange = (0, $42omo.useMemo)(()=>(selectedSortOption)=>()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: analyticsSource,
                        action: 'clicked',
                        actionSubject: 'dropdownItem',
                        actionSubjectId: 'sortingOrderDropdownItem',
                        attributes: {
                            previousSortingScheme: value,
                            newSortingScheme: selectedSortOption
                        }
                    }
                }).fire();
                onChange(selectedSortOption);
            }, [
        analyticsSource,
        onChange,
        createAnalyticsEvent,
        value
    ]);
    if (!value) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eZElj.LoadingSortByDropdown), null);
    const isSortByRecommendedSelected = value === (0, $ae5hk.SortOrders).RELEVANCY_SORT;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9cCqQ.SortByDropdownWrapper), {
        "data-testid": "templates-sort-by-dropdown"
    }, showLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9cCqQ.SortByLabel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $2de8447cc174b523$export$a7357cdd1f0b0168.sortByLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9cCqQ.DropdownWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: isSortByRecommendedSelected && !isMenuOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $2de8447cc174b523$export$a7357cdd1f0b0168.sortByRecommendedTooltip) : '',
                testId: "templates-sort-by-dropdown-tooltip"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ...props,
                appearance: "subtle",
                isDisabled: isDisabled,
                id: "templates-sort-by-order",
                shouldFitContainer: true,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    textAlign: 'left'
                },
                isSelected: isMenuOpen,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "",
                    size: "small"
                }),
                testId: "templates-sort-by-order-button",
                ref: triggerRef
            }, options[value])),
        isOpen: isMenuOpen,
        onOpenChange: handleOpenChange,
        placement: "bottom-start",
        shouldFlip: false,
        testId: "templates-sort-by-order",
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dHU8P.SortByDropdownClickItem), {
        msg: $2de8447cc174b523$export$a7357cdd1f0b0168.recommendedLabel,
        onClick: handleSortOrderChange((0, $ae5hk.SortOrders).RELEVANCY_SORT)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dHU8P.SortByDropdownClickItem), {
        msg: $2de8447cc174b523$export$a7357cdd1f0b0168.alphabeticalLabel,
        onClick: handleSortOrderChange((0, $ae5hk.SortOrders).ALPHABETICAL_SORT)
    })))));
};
const $2de8447cc174b523$export$f10bf403de21e958 = /*#__PURE__*/ (0, $42omo.memo)($2de8447cc174b523$export$90a65afdbb90e76e);
module.exports["SortByDropdown"] = $2de8447cc174b523$export$f10bf403de21e958;

});

parcelRegister("dHU8P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $dAYOx = parcelRequire("dAYOx");

const $34d6d8c57f5e28f9$export$89426c56882990b = ({ msg: msg, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
        ...msg,
        key: msg.id
    }));
module.exports["SortByDropdownClickItem"] = $34d6d8c57f5e28f9$export$89426c56882990b;

});

parcelRegister("66Dsm", function(module, exports) {

var $aUp28 = parcelRequire("aUp28");


var $6KWXd = parcelRequire("6KWXd");


var $bQm3c = parcelRequire("bQm3c");


var $1JEqL = parcelRequire("1JEqL");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");


var $jMyy4 = parcelRequire("jMyy4");

const $13240525381ea71e$export$10e7c37d48e20bae = 11;
const $13240525381ea71e$export$d227e9a2756e8472 = 7;
const $13240525381ea71e$export$d18f171722e15763 = ()=>{
    const { isLicensed: isLicensed, userId: userId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { data: editorOnboardingData, loading: editorOnboardingLoading, error: editorOnboardingError } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)));
    const { data: userContentData, loading: userContentLoading, error: userContentError } = (0, $jMyy4.useQueryInterop)((0, $6KWXd.default), {
        variables: {
            cql: `type = 'page' AND creator = '${userId}'`
        },
        skip: !isLicensed || !isLoggedIn,
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    const { data: privilegeData, loading: privilegeLoading, error: privilegeError } = (0, $jMyy4.useQueryInterop)((0, $aUp28.default), {
        __callerPackage__: "@confluence/onboarding-helpers"
    });
    // Onboarding related variables
    const deserializedEditorOnboardingState = (0, $ivb8S.deserializeState)(editorOnboardingData);
    const { editorOnboardingEligiblity: editorOnboardingEligiblity } = deserializedEditorOnboardingState;
    const queriesLoadingOrErrored = editorOnboardingLoading || Boolean(editorOnboardingError) || userContentLoading || Boolean(userContentError) || privilegeLoading || Boolean(privilegeError);
    const isProductOrSiteAdmin = (0, $1JEqL.getIsProductOrSiteAdminFromQuery)(privilegeData);
    const hasQueryErrors = Boolean(editorOnboardingError) || Boolean(userContentError) || Boolean(privilegeError);
    // Admins get automatically created 9 pages, while Nth users only get created 5.
    const publishedPagesThreshold = isProductOrSiteAdmin ? $13240525381ea71e$export$10e7c37d48e20bae : $13240525381ea71e$export$d227e9a2756e8472;
    // If there is no data on how many pages they published, then assume that the template shouldn't be visible.
    const numberOfPagesPublished = userContentData?.search?.count ?? publishedPagesThreshold;
    const shouldIncludeEditorTutorialTemplate = !queriesLoadingOrErrored && // Show the template if onboarding state is not loading / has an error
    Boolean(editorOnboardingEligiblity) && // Has to be onboarding eligible (new user)
    numberOfPagesPublished < publishedPagesThreshold; // Don't show if they have published 2 pages (excluding the auto-generated pages)
    return {
        shouldIncludeEditorTutorialTemplate: shouldIncludeEditorTutorialTemplate,
        userContentError: userContentError,
        editorOnboardingError: editorOnboardingError,
        privilegeError: privilegeError,
        isProductOrSiteAdmin: isProductOrSiteAdmin,
        queriesLoadingOrErrored: queriesLoadingOrErrored,
        hasQueryErrors: hasQueryErrors
    };
};
module.exports["useIncludeEditorTutorialTemplate"] = $13240525381ea71e$export$d18f171722e15763;

});

parcelRegister("aUp28", function(module, exports) {
/**
 * @generated SignedSource<<1469c48163eef1d6872c9ec34d9975f0>>
 * @relayHash b0859ec85298cdcc3abeeb1b76428f06
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 370ec9eee83808f99e9887355ed073323a91ceb9d4f67e1676c11d34f8e236d1
const $7b4771bbfec2ff2e$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        },
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        },
        {
            "kind": "ScalarField",
            "name": "hasUserAccessAdminRole"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIncludeEditorTutorialTemplateGetUserPrivilegesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIncludeEditorTutorialTemplateGetUserPrivilegesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "b0859ec85298cdcc3abeeb1b76428f06",
            "id": "370ec9eee83808f99e9887355ed073323a91ceb9d4f67e1676c11d34f8e236d1",
            "metadata": {},
            "name": "useIncludeEditorTutorialTemplateGetUserPrivilegesQuery",
            "operationKind": "query",
            "text": "query useIncludeEditorTutorialTemplateGetUserPrivilegesQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation,targetType}}},isSiteAdmin,hasUserAccessAdminRole}"
        }
    };
}();
$7b4771bbfec2ff2e$var$node.hash = "f89395b5bfa711d4abb146bb5f205ba7";
var $7b4771bbfec2ff2e$export$2e2bcd8739ae039 = $7b4771bbfec2ff2e$var$node;
module.exports["default"] = $7b4771bbfec2ff2e$export$2e2bcd8739ae039;

});

parcelRegister("6KWXd", function(module, exports) {
/**
 * @generated SignedSource<<d0088fed8d9bb47d7856217380291ada>>
 * @relayHash 01fffd726d239a3885cdda05ee671cfc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5e63e2c8ebfdf4d965dba277c3c32a8a04deda6abf4222f96546f817f5440d4d
const $fe23f76b0dba2c1c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cql"
        }
    ], v1 = [
        {
            "alias": "search",
            "args": [
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 12
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIncludeEditorTutorialTemplateGetUserContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIncludeEditorTutorialTemplateGetUserContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "01fffd726d239a3885cdda05ee671cfc",
            "id": "5e63e2c8ebfdf4d965dba277c3c32a8a04deda6abf4222f96546f817f5440d4d",
            "metadata": {},
            "name": "useIncludeEditorTutorialTemplateGetUserContentQuery",
            "operationKind": "query",
            "text": "query useIncludeEditorTutorialTemplateGetUserContentQuery($cql:String!){search:confluence_search(cql:$cql,first:12){count},isSiteAdmin}"
        }
    };
}();
$fe23f76b0dba2c1c$var$node.hash = "faa88759211e6aba8a9b90c957005513";
var $fe23f76b0dba2c1c$export$2e2bcd8739ae039 = $fe23f76b0dba2c1c$var$node;
module.exports["default"] = $fe23f76b0dba2c1c$export$2e2bcd8739ae039;

});

parcelRegister("1JEqL", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $eJhXX = parcelRequire("eJhXX");


var $icMDs = parcelRequire("icMDs");

function $e18808c613ab8370$export$138f02318593ab4(queryData) {
    const userPrivilege = (0, $eJhXX.getUserPrivilegeFromQuery)(queryData);
    return userPrivilege === (0, $icMDs.UserPrivilege).PRODUCT_ADMIN || userPrivilege === (0, $icMDs.UserPrivilege).SITE_ADMIN;
}
module.exports["getIsProductOrSiteAdminFromQuery"] = $e18808c613ab8370$export$138f02318593ab4;

});

parcelRegister("eJhXX", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $fWkVZ = parcelRequire("fWkVZ");


var $w033M = parcelRequire("w033M");


var $icMDs = parcelRequire("icMDs");

function $a7000458c02582d2$export$d036114e4ad5c4c3(queryData) {
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(queryData);
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(queryData);
    return typeof queryData === 'undefined' ? undefined : isSiteAdmin ? (0, $icMDs.UserPrivilege).SITE_ADMIN : isProductAdmin ? (0, $icMDs.UserPrivilege).PRODUCT_ADMIN : (0, $icMDs.UserPrivilege).NON_ADMIN;
}
module.exports["getUserPrivilegeFromQuery"] = $a7000458c02582d2$export$d036114e4ad5c4c3;

});

parcelRegister("icMDs", function(module, exports) {
var $296e2d91f769f195$export$fa8745fb6d256802 = /*#__PURE__*/ function(UserPrivilege) {
    UserPrivilege["NON_ADMIN"] = "nonAdmin";
    UserPrivilege["PRODUCT_ADMIN"] = "productAdmin";
    UserPrivilege["SITE_ADMIN"] = "siteAdmin";
    return UserPrivilege;
}({});
module.exports["UserPrivilege"] = $296e2d91f769f195$export$fa8745fb6d256802;

});

parcelRegister("bvJMy", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gI8uy = parcelRequire("gI8uy");


var $cOrQJ = parcelRequire("cOrQJ");

const $82c992371ed08bb5$export$fd017b91d8968d63 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    const { label: label, size: size, testId: testId, spacing: spacing } = t0;
    const theme = (0, $cOrQJ.default)();
    const primaryColor = theme.colorMode === "dark" ? "var(--ds-icon-accent-yellow, #B38600)" : "var(--ds-icon-accent-orange, #E06C00)";
    let t1;
    if ($[0] !== size) {
        t1 = size && {
            size: size
        };
        $[0] = size;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== testId) {
        t2 = testId && {
            testId: testId
        };
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== label || $[5] !== primaryColor || $[6] !== spacing || $[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gI8uy))), {
            label: label,
            color: primaryColor,
            ...t1,
            ...t2,
            spacing: spacing
        });
        $[4] = label;
        $[5] = primaryColor;
        $[6] = spacing;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ label: label, size: size, testId: testId, spacing: spacing })=>{
    const theme = (0, $cOrQJ.default)();
    const primaryColor = (0, $42omo.useMemo)(()=>{
        return theme.colorMode === 'dark' ? "var(--ds-icon-accent-yellow, #B38600)" : "var(--ds-icon-accent-orange, #E06C00)";
    }, [
        theme.colorMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gI8uy))), {
        label: label,
        color: primaryColor,
        ...size && {
            size: size
        },
        ...testId && {
            testId: testId
        },
        spacing: spacing
    });
};
module.exports["StarSelectedIcon"] = $82c992371ed08bb5$export$fd017b91d8968d63;

});

parcelRegister("4B2M3", function(module, exports) {
/* ObservableSpinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $9hlns = parcelRequire("9hlns");


var $l8oxh = parcelRequire("l8oxh");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5ccd6b86c893b680$var$SpinnerWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1ylp _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $5ccd6b86c893b680$var$SpinnerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41bpf _1reo15vq _18m915vq _1tke1tcg",
            __cmplp.className
        ])
    });
});
const $5ccd6b86c893b680$export$9c05ccc6295d539b = ({ onScrollTo: onScrollTo, testId: testId, cursor: cursor, observerOptions: observerOptions, spinnerSize: spinnerSize = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l8oxh.InfiniteScroll), {
        onScrollTo: onScrollTo,
        cursor: cursor,
        observerOptions: observerOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5ccd6b86c893b680$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5ccd6b86c893b680$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: spinnerSize,
        testId: testId
    }))));
};
module.exports["ObservableSpinner"] = $5ccd6b86c893b680$export$9c05ccc6295d539b;

});

parcelRegister("l8oxh", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $cb0d4ce40dbff1b4$export$c5295390d6167a3e = ({ onScrollTo: onScrollTo, cursor: cursor, observerOptions: observerOptions, children: children })=>{
    const loaderTarget = (0, $42omo.useRef)(null);
    const previousCursor = (0, $42omo.useRef)(null);
    // This function is called by the IntersectionObserver API when "loaderTarget" UI element
    // changes visibility.  If it has become visible (typically by user scrolling), call our
    // scroll handler and the parent will attempt to load more data
    const handleIntersect = (0, $42omo.useCallback)((entries)=>{
        // Sometimes based on an unknown render race condition, the previous IntersectionObserver is not
        // properly cleared before the next one is observed, which causes the 0th indexed IntersectionObserver
        // to never be intersecting, which causes the onScrollTo callback to not be called when it should be.
        // To fix this just get rid of the old observer if it is not properly cleaned up.
        if (entries.length > 1) entries.shift();
        // On the first scroll the previousCursor = null and cursor is a string or undefined
        // Intersection can occur multiple times but we only call onScrollTo again if we have a new cursor.
        if (entries?.[0]?.isIntersecting && cursor !== previousCursor.current) {
            previousCursor.current = cursor;
            onScrollTo();
        }
    }, [
        onScrollTo,
        cursor
    ]);
    // IntersectionObserver detects when our target element becomes visible
    (0, $42omo.useEffect)(()=>{
        // Adding a positive 'rootMargin' and setting 'root' to the scroll container *should* trigger
        // a positive 'intersection' result (thus loading results) before this element even comes into view
        // (when it is Xpx away from the viewport). 'rootMargin' follows CSS 'margin' syntax.
        // However, this doesn't seem to be working, intersection only triggers when element is in viewport.
        // Have also attempted to pass in a ref from the table tree container instead of querying the document,
        // but that also does not work.
        // @TODO figure out what is wrong here.
        // eslint-disable-next-line
        const observer = new IntersectionObserver(handleIntersect, observerOptions);
        const target = loaderTarget?.current;
        if (target) observer.observe(target);
        return ()=>{
            if (target) observer.unobserve(target);
            observer.disconnect();
        };
    }, [
        loaderTarget,
        handleIntersect,
        observerOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cb0d4ce40dbff1b4$var$LoaderTarget, {
        ref: loaderTarget
    }, children);
};
const $cb0d4ce40dbff1b4$var$LoaderTarget = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref
    }, children));
module.exports["InfiniteScroll"] = $cb0d4ce40dbff1b4$export$c5295390d6167a3e;

});


//# sourceMappingURL=TemplateList.ce40d047.js.map
